module.exports = __webpack_public_path__ + "img/home_inactive.e55fcecf.svg";